const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkill(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 103.257-23.648 10.019c-6.558 2.778-13.715-2.422-13.1-9.517l2.221-25.587-16.836-19.395c-4.669-5.378-1.935-13.792 5.004-15.399l25.021-5.795 13.243-22.005c3.672-6.102 12.519-6.102 16.192 0l13.243 22.005 25.021 5.795c6.939 1.607 9.672 10.021 5.004 15.399l-16.836 19.395 2.221 25.587c.616 7.095-6.542 12.296-13.1 9.517L256 103.257zM407.368 114.237l23.648 10.019c6.558 2.778 13.715-2.422 13.1-9.517l-2.221-25.587 16.836-19.395c4.669-5.378 1.935-13.792-5.004-15.399l-25.021-5.795-13.243-22.005c-3.672-6.102-12.52-6.102-16.192 0l-13.243 22.005-25.021 5.795c-6.939 1.607-9.672 10.021-5.004 15.399l16.836 19.395-2.221 25.587c-.616 7.095 6.542 12.296 13.1 9.517l23.65-10.019zM104.632 114.237l-23.648 10.019c-6.558 2.778-13.715-2.422-13.1-9.517l2.221-25.587-16.836-19.395c-4.669-5.378-1.935-13.792 5.004-15.399l25.021-5.795 13.243-22.005c3.672-6.102 12.519-6.102 16.192 0l13.243 22.005 25.021 5.795c6.939 1.607 9.672 10.021 5.004 15.399L139.16 89.152l2.221 25.587c.616 7.095-6.542 12.296-13.1 9.517l-23.649-10.019z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#0e9941",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#33cccc",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.05 389.004c-20.628-8.394-35.165-28.641-35.165-52.278v-74.389c0-58.606 47.51-106.115 106.115-106.115h0c58.606 0 106.115 47.51 106.115 106.115v74.584c0 23.477-14.339 43.6-34.73 52.099M167.118 454.72V501M344.882 454.72V501",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m290.39 348.417-.023 38.179 50.678 3.552c35.596 2.495 63.197 32.099 63.197 67.781V501H107.759v-43.071c0-35.683 27.601-65.287 63.197-67.781l50.678-3.552.023-38.179",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.633 386.595 256 414.691l34.367-28.096M315.939 259.273v39.023c0 33.103-26.836 59.939-59.939 59.939h0c-33.103 0-59.939-26.836-59.939-59.939v-39.023h119.878z",
    style: {
      strokeWidth: 22,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    fill: "none",
    stroke: "#112d55",
    strokeWidth: 22,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    "data-original": "#000000",
    opacity: 1,
    className: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.31fb79318b10d6119dd5a52cb3895808.svg";
export { ForwardRef as ReactComponent };